import { useContext } from 'react';
import { AccordionContext, AccordionContextProps } from '../context';

export function useAccordionContext(): AccordionContextProps {
  const contextAccordion = useContext(AccordionContext);

  // if these contexts are not defined, that means the AccordionTab is not contained within an Accordion. Therefore, throwing an error.
  if (!contextAccordion) {
    throw new Error('AccordionTab must be used within an Accordion component');
  }

  return contextAccordion;
}
